export default {"src":"/_next/static/media/logo.6263393a.svg","height":32,"width":180,"blurWidth":0,"blurHeight":0};